module.exports = __webpack_public_path__ + "img/表1-5尺寸标注常用的符号及缩写词.f2df2f2f.png";